import type { Language } from './types';

export const DEFAULT_LANGUAGE: Language = 'en';

export const SUPPORTED_LANGUAGES: Language[] = ['en', 'ru', 'de'];

export const SITE_URL = 'https://vajaja.dev';

export const ASSETS_BASE = '/assets';

export const DATA_BASE = '/data';
